module.exports = __webpack_public_path__ + "img/python-certifique.329e629f.png";